import { ref, readonly } from 'vue';
import { loadingController } from '@ionic/vue';

const isLoading = ref(false);
const fullPageLoader = ref<HTMLIonLoadingElement | null>(null);

export function useLoading() {
  async function startLoader() {
    isLoading.value = true;
  }

  async function dismissLoader() {
    isLoading.value = false;
  }

  async function startFullPageLoader() {
    if (fullPageLoader.value) return;
    fullPageLoader.value = await loadingController.create({
      spinner: 'crescent',
      cssClass: 'custom-loading',
    });
    isLoading.value = true;
    await fullPageLoader.value.present();
  }

  async function dismissFullPageLoader() {
    await fullPageLoader.value?.dismiss();
    fullPageLoader.value = null;
    isLoading.value = false;
  }

  return {
    startLoader,
    dismissLoader,
    startFullPageLoader,
    dismissFullPageLoader,
    isLoading: readonly(isLoading),
  };
}
